/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} No_Transcript_FoundInputs */



/**
* | output |
* | --- |
* | "No Transcript Found" |
*
* @param {No_Transcript_FoundInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const no_transcript_found = /** @type {((inputs?: No_Transcript_FoundInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<No_Transcript_FoundInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucune transcription trouvée")
	if (locale === "de") return /** @type {LocalizedString} */ ("Kein Transkript gefunden")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessuna trascrizione trovata")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Текст расшифровки не найден")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se encontró ninguna transcripción")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("未找到文字记录")
	if (locale === "ja") return /** @type {LocalizedString} */ ("トランスクリプトが見つかりません")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कोई प्रतिलेख नहीं मिला")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Nenhuma transcrição encontrada")
	return /** @type {LocalizedString} */ ("No Transcript Found")
});